<script>
  import { Alert } from 'element-ui'
  export default {
    name:'ElAlert',
    extends:Alert
  }
</script>
